import { CapacitorCookies } from '@capacitor/core';
import { AUTH_DOMAINS } from 'modules/authentication/helpers/constants';
import { WlWindow } from 'typings/globals/cordova';
import { isAndroidApp, isCordova } from 'utils/platform';
import useAuthStore from '~/authentication/store';

declare const window: WlWindow;

// TODO: The app shouldn't be responsible for clearing cookies - the server's
// Set-Cookie with Max-Age=0 should handle this. This is a workaround for
// InAppBrowser/WebView cookie store separation.
const BETTER_AUTH_PREFIX =
  ENVIRONMENT === 'test' ? '__Secure-test-better-auth' : '__Secure-better-auth';

const AUTH_COOKIES = [
  `${BETTER_AUTH_PREFIX}.session_token`,
  `${BETTER_AUTH_PREFIX}.state`,
  'better-auth.session_token',
  'better-auth.state',
  '__Secure-next-auth.session-token',
  '__Secure-next-auth.pkce.code_verifier',
  '__Secure-next-auth.state',
  '__Secure-next-auth.nonce',
  '__Secure-next-auth.csrf-token',
  '__Secure-next-auth.callback-url',
  'dev-next-auth.session-token',
  'dev-next-auth.pkce.code_verifier',
  'dev-next-auth.state',
  'dev-next-auth.nonce',
  'dev-next-auth.csrf-token',
  'dev-next-auth.callback-url',
  'PLAY_SESSION',
];

export async function clearAuthCookies(): Promise<void> {
  if (!isCordova()) return;

  for (const url of AUTH_DOMAINS) {
    for (const key of AUTH_COOKIES) {
      try {
        await CapacitorCookies.deleteCookie({ url, key });
      } catch {
        // Ignore - cookie may not exist
      }
    }
  }
}

export const forceTokenRemoval = (error: any, shouldReload: boolean) => {
  if (document.cookie.length < 4000) {
    return;
  }
  window.cookieMaster.clearCookies(
    () => {
      console.error(
        'Cookies have been cleared because of possible 431 response code',
        error,
      );
      useAuthStore.getState().logout();
      if (shouldReload) {
        window.location.reload();
      }
    },
    () => {
      console.error('Cookies could not be cleared');
      if (shouldReload) {
        window.location.reload();
      }
    },
  );
};

export const shouldCheckForTooLargeCookies = () =>
  isAndroidApp() && window.cookieMaster;
